import countTo, { type CountToOptions } from "@client/lib/jquery/countTo";
import { makeWith, makeWrap } from "./factory";

export interface CountToProps {
  countToOptions: CountToOptions;
}

export const withCountTo = makeWith<CountToProps>(
  (element: HTMLElement, props: CountToProps) => countTo(element, props.countToOptions),
  "countToOptions"
);

const countToTag = makeWrap<CountToProps>(withCountTo);
export default countToTag;
